import get from 'lodash/get';

export const getAccountType = (currentUser) => {
  return get(currentUser, 'attributes.profile.metadata.accountType', null);
}

export const isOwnerSystemAccount = (currentUser) => {
  return getAccountType(currentUser) === 'systemOwner'; 
}

export const isAdminAccount = (currentUser) => {
  return getAccountType(currentUser) === 'admin' || getAccountType(currentUser) === 'systemOwner'; 
}